export const paths = {
  login: {
    path: '/',
    getHref: (redirectTo?: string | null | undefined) =>
      `/${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
  },

  app: {
    root: {
      path: '/app',
      getHref: () => '/app',
    },
    dashboard: {
      path: '',
      getHref: () => '/app',
    },
    cashback: {
      path: 'cashback',
      getHref: () => '/app/cashback',
    },
    profile: {
      path: 'profile',
      getHref: () => '/app/profile',
    },
    requests: {
      list: {
        path: 'requests',
        getHref: () => '/app/requests',
      },
      detail: {
        path: 'requests/:id',
        getHref: (id: string) => `/app/requests/${id}`,
      },
      createProposals: {
        path: 'requests/:id/create-proposals',
        getHref: (id: string) => `/app/requests/${id}/create-proposals`,
      },
    },
    practices: {
      list: {
        path: 'practices',
        getHref: () => '/app/practices',
      },
      detail: {
        path: 'practices/:id',
        getHref: (id: string) => `/app/practices/${id}`,
      },
      edit: {
        path: 'practices/:id/modifica',
        getHref: (id: string) => `/app/practices/${id}/modifica`,
      },
    },
    catalog: {
      operators: {
        path: 'catalog/operators',
        getHref: () => '/app/catalog/operators',
      },
      pricingConstants: {
        path: 'catalog/pricing-constants',
        getHref: () => '/app/catalog/pricing-constants',
      },
      offers: {
        list: {
          path: 'catalog/offers',
          getHref: () => '/app/catalog/offers',
        },
        new: {
          path: 'catalog/offers/new',
          getHref: () => '/app/catalog/offers/new',
        },
        detail: {
          path: 'catalog/offers/:id',
          getHref: (id: string) => `/app/catalog/offers/${id}`,
        },
      },
    },
  },
} as const;
